module.exports = { version: "0.3.31" };


//////////////////
// WEBPACK FOOTER
// ./~/datocms-client/lib/pkg.js
// module id = 344
// module chunks = 0